
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns84ff4599a439e035424a6bad6a377201en from './en.yaml'
            i18n.addResourceBundle('en', '84ff4599a439e035424a6bad6a377201', flattenObject(ns84ff4599a439e035424a6bad6a377201en), true, true);
        
        export default '84ff4599a439e035424a6bad6a377201';
    